/**
 * Analytics Overview (situation board) — denser top-N signals.
 * Detail tabs own full tables, gauges, search, and expand.
 */
export const OVERVIEW_BREAKDOWN_LIMIT = 10

/** Keep 2×2 cards from growing unbounded when lists are denser */
export const OVERVIEW_LIST_CLASS = "max-h-80 overflow-y-auto min-h-0" as const
